<template>
  <div>
    <v-toolbar flat app absolute color="black" height="40px">
      <vc-share-a href="#">
        <img height="20px" src="./assets/logo_clip.png" />
      </vc-share-a>
      <v-spacer></v-spacer>
      <vc-share-a class="pr-3" href="#" v-if="false"
        >このサービスについて</vc-share-a
      >
      <vc-share-a href="#" v-if="false">使い方</vc-share-a>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: "vc-share-lp-appbar"
};
</script>

<style scoped>
/* TODO:module化 */
a {
  color: white;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>
